import {
  KeyboardArrowLeft,
  KeyboardArrowRight,
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
} from '@mui/icons-material'
import { IconButton, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import { map } from 'lodash'
import styles from './CustomTable.module.css'
import { CustomTableHead } from './CustomTableHead'

interface CustomTableProps {
  headTitles: string[]
  order: 'asc' | 'desc' | undefined
  orderBy: string | undefined
  data: { hasBackground: boolean; cell: React.ReactNode[] }[]
  onRequestSort: (property: string) => void | undefined
  onPageChange: (page: number) => void | undefined
  page: number | undefined
  total: number | undefined
  hasBorder?: boolean
  isPaginated?: boolean
  centerHeadTitles?: boolean
  firstColumnMaxWidth?: boolean
  paginationInfo?: React.ReactNode
  sortableColumns?: string[]
  optionalText?: React.ReactNode
}

export const CustomTable = ({
  headTitles,
  order,
  orderBy,
  data,
  onRequestSort,
  onPageChange,
  page,
  total,
  hasBorder = false,
  isPaginated = true,
  centerHeadTitles = false,
  firstColumnMaxWidth = false,
  paginationInfo,
  sortableColumns,
  optionalText,
}: CustomTableProps) => {
  return (
    <>
      <TableContainer className={styles.tableContainer}>
        <Table sx={{ minWidth: headTitles.length * 100 }}>
          <CustomTableHead
            headTitles={headTitles}
            onRequestSort={onRequestSort}
            order={order}
            orderBy={orderBy}
            centerHeadTitles={centerHeadTitles}
            sortableColumns={sortableColumns}
          />
          <TableBody className={styles.tableBody}>
            {map(data, (row, rowIndex) => (
              <TableRow
                key={`row-${rowIndex}`}
                className={styles.tableRow}>
                {map(row.cell, (cell, cellIndex) => (
                  <TableCell
                    sx={{
                      borderRight: hasBorder
                        ? row.hasBackground
                          ? '1px solid rgba(245, 245, 245, 1)'
                          : '1px solid rgba(232, 232, 232, 1)'
                        : 'none',
                      maxWidth: firstColumnMaxWidth && cellIndex === 0 ? 'none !important' : undefined,
                    }}
                    className={row.hasBackground ? styles.tableCellBackground : styles.tableCell}
                    key={`row-${rowIndex}-cell-${cellIndex}`}>
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>

        {optionalText && <div className={styles.optionalTextContainer}>{optionalText}</div>}

        {isPaginated && page !== undefined && total !== undefined && (
          <div className={styles.paginationInfoContainer}>
            {paginationInfo}
            <div className={styles.paginationContainer}>
              <IconButton
                className={styles.paginationButton}
                disabled={page === 1}
                onClick={() => {
                  onPageChange(1)
                }}>
                <KeyboardDoubleArrowLeft />
              </IconButton>
              <IconButton
                className={styles.paginationButton}
                disabled={page === 1}
                onClick={() => {
                  onPageChange(page - 1)
                }}>
                <KeyboardArrowLeft />
              </IconButton>
              <p>{`${page} - ${total}`}</p>
              <IconButton
                className={styles.paginationButton}
                disabled={page === total}
                onClick={() => {
                  onPageChange(page + 1)
                }}>
                <KeyboardArrowRight />
              </IconButton>
              <IconButton
                className={styles.paginationButton}
                disabled={page === total}
                onClick={() => {
                  onPageChange(total)
                }}>
                <KeyboardDoubleArrowRight />
              </IconButton>
            </div>
          </div>
        )}
      </TableContainer>
    </>
  )
}
